import actions from './actions';

export default {
  getTimeslot: actions.getTimeslot,
  getTimeslots: actions.getTimeslots,
};
